import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Main from '../components/Main/Main';
import Intro from './../pages/Intro';
import History from '../pages/History';
import Directions from '../pages/Directions';
import BoardList from '../components/Board/BoardList';
import BoardDetail from '../components/Board/BoardDetail';

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Main />}></Route>
      {/* ABOUT */}
      <Route path="/about/intro" element={<Intro />}></Route>
      <Route path="/about/history" element={<History />}></Route>
      <Route path="/about/directions" element={<Directions />}></Route>
      {/* GAMES, JOURNAL, NEWS, CONTACT US*/}
      <Route path="/board/:category" element={<BoardList />}></Route>
      <Route path="/board/:category/:idx" element={<BoardDetail />}></Route>
    </Routes>
  );
};

export default Router;
